import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import NProgress from 'nprogress'

import { CurrentEnvironment, ICurrentEnvironment } from '@/config'

export class AxiosClient {
  private env: ICurrentEnvironment = new CurrentEnvironment() as ICurrentEnvironment
  constructor() {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = this.env.baseUrl
    Vue.axios.interceptors.request.use((config) => {
      NProgress.start()
      return config
    })

    // before a response is returned stop nprogress
    Vue.axios.interceptors.response.use((response) => {
      NProgress.done()
      return response
    })
  }

  get(resource: string, slug: string = ''): Promise<any> {
    if (resource.includes('FSGalaxyReportingApi') ){
      Vue.axios.defaults.baseURL = this.env.galaxyUrl
    } else if (resource.includes('FSReportingApiFirebase')){
      Vue.axios.defaults.baseURL = this.env.reportUrl
    } else if (resource.includes('FSGoogleApiFirebase')){
      Vue.axios.defaults.baseURL = this.env.googleUrl
    } else {
      Vue.axios.defaults.baseURL = process.env.VUE_APP_AUTH_API_URL
    }

    return Vue.axios.get(`${resource}/${slug}`)
  }

  query(resource: string, params: any): Promise<any> {
    if (resource.includes('FSGalaxyReportingApi') ){
      Vue.axios.defaults.baseURL = this.env.galaxyUrl
    } else if (resource.includes('FSReportingApiFirebase')){
      Vue.axios.defaults.baseURL = this.env.reportUrl
    } else if (resource.includes('FSGoogleApiFirebase')){
      Vue.axios.defaults.baseURL = this.env.googleUrl
    } else {
      Vue.axios.defaults.baseURL = process.env.VUE_APP_AUTH_API_URL
    }

    return Vue.axios.get(resource, { params: params })
  }

  post(resource: string, params: any): Promise<any> {
    if (resource.includes('FSGalaxyReportingApi') ){
      Vue.axios.defaults.baseURL = this.env.galaxyUrl
    } else if (resource.includes('FSReportingApiFirebase')){
      Vue.axios.defaults.baseURL = this.env.reportUrl
    } else if (resource.includes('FSGoogleApiFirebase')){
      Vue.axios.defaults.baseURL = this.env.googleUrl
    } else {
      Vue.axios.defaults.baseURL = process.env.VUE_APP_AUTH_API_URL
    }

    return Vue.axios.post(`${resource}`, params)
  }

  put(resource: string, params: any): Promise<any> {
    if (resource.includes('FSGalaxyReportingApi') ){
      Vue.axios.defaults.baseURL = this.env.galaxyUrl
    } else if (resource.includes('FSReportingApiFirebase')){
      Vue.axios.defaults.baseURL = this.env.reportUrl
    } else if (resource.includes('FSGoogleApiFirebase')){
      Vue.axios.defaults.baseURL = this.env.googleUrl
    } else {
      Vue.axios.defaults.baseURL = process.env.VUE_APP_AUTH_API_URL
    }

    return Vue.axios.put(`${resource}`, params)
  }

  delete(resource: string, params: any): Promise<any> {
    if (resource.includes('FSGalaxyReportingApi') ){
      Vue.axios.defaults.baseURL = this.env.galaxyUrl
    } else if (resource.includes('FSReportingApiFirebase')){
      Vue.axios.defaults.baseURL = this.env.reportUrl
    } else if (resource.includes('FSGoogleApiFirebase')){
      Vue.axios.defaults.baseURL = this.env.googleUrl
    } else {
      Vue.axios.defaults.baseURL = process.env.VUE_APP_AUTH_API_URL
    }

    return Vue.axios.delete(`${resource}`, params)
  }
}

//For initial testing of fs-sales-api
// if(resource.includes("Sales_Raw")){
//   Vue.axios.defaults.baseURL = "http://localhost:5000";
// }
// else{
//   Vue.axios.defaults.baseURL = this.env.baseUrl;
// }
